import { render, staticRenderFns } from "./yj_list.vue?vue&type=template&id=76bc7228&scoped=true&"
import script from "./yj_list.vue?vue&type=script&lang=js&"
export * from "./yj_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bc7228",
  null
  
)

export default component.exports